import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import {
  checkIsNoResultToolOutput,
  type NoResultToolOutput,
} from "@repo/app-types/agents/noResultToolOutput";
import type {
  ProposeKnowledgeDocumentEditToolInput,
  ProposeKnowledgeDocumentEditToolOutput,
} from "@repo/app-types/entities/knowledgeBaseAttachmentProposal";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const ProposeKnowledgeDocumentEditTool: ToolComponent<
  ProposeKnowledgeDocumentEditToolInput,
  | ProposeKnowledgeDocumentEditToolOutput
  | NoResultToolOutput
  | MastraErrorToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Proposing a document edit...";
    }
    if (checkIsMastraErrorToolOutput(props.output)) {
      return "An error occurred while proposing the document edit";
    }
    // A refusal the user can act on — a synced document, an unknown id,
    // content already saved — resolves with its reason instead of a proposal.
    if (checkIsNoResultToolOutput(props.output)) {
      return props.output.message;
    }
    return `Proposed an edit to "${props.output.document_title}"`;
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
